var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "시나리오 목록",
          columns: _vm.grid.columns,
          gridHeight: _vm.grid.height,
          data: _vm.grid.data,
          merge: _vm.grid.merge,
          filtering: false,
          columnSetting: false,
          usePaging: false,
          editable: false,
        },
        scopedSlots: _vm._u([
          {
            key: "customArea",
            fn: function ({ props, col }) {
              return [
                col.name === "customCol"
                  ? [
                      !_vm.param.vendorFlag
                        ? [
                            props.row["sopImprovementIds"] &&
                            props.row["ibmStepNames"]
                              ? _vm._l(
                                  _vm.$comm.ibmTagItems(
                                    props.row,
                                    _vm.colorItems
                                  ),
                                  function (item, index) {
                                    return _c(
                                      "q-chip",
                                      {
                                        key: index,
                                        staticStyle: {
                                          "margin-bottom": "4px !important",
                                        },
                                        attrs: {
                                          color: item.color,
                                          clickable: true,
                                          "text-color": "white",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.linkClick(
                                              item,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(" " + _vm._s(item.title) + " "),
                                        _c("c-assess-tooltip", {
                                          attrs: {
                                            ibmTooltip: item.ibmTooltip,
                                            ibmClassCd: item.ibmClassCd,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                )
                              : _vm._e(),
                          ]
                        : [
                            props.row["ram4mAssessImprIds"] &&
                            props.row["stepFlagNames"]
                              ? _vm._l(
                                  _vm.$comm.fmImprTagItems(props.row),
                                  function (item, index) {
                                    return _c(
                                      "q-chip",
                                      {
                                        key: index,
                                        staticStyle: {
                                          "margin-bottom": "4px !important",
                                        },
                                        attrs: {
                                          color: item.color,
                                          clickable: true,
                                          "text-color": "white",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.linkClick(
                                              item,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(" " + _vm._s(item.title) + " "),
                                        _c("c-assess-tooltip", {
                                          attrs: {
                                            isVendor: "",
                                            ibmTooltip: item.ibmFmTooltip,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                )
                              : _vm._e(),
                          ],
                    ]
                  : col.name === "picture"
                  ? [
                      _c("q-btn", {
                        staticClass: "tableinnerBtn",
                        attrs: {
                          flat: "",
                          align: "center",
                          color: "blue-6",
                          label: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.openPicture(props, col)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  props.row.editFlag !== "C"
                                    ? [_vm._v(" 사진 ")]
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }